<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=contacts_list>Список договоров</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
                <span v-if="forms.contracts.selectedItem">
                    Добавить дополнительное соглашение к договору {{ forms.contracts.selectedItem.name }} №{{ forms.contracts.selectedItem.number }}
                </span>

                <span v-else>
                    Добавить дополнительное соглашение к договору
                </span>
            </li>
        </ol>
    </nav>

    <form class="form-narrow">
        <div v-if="forms.contracts.selectedItem" class="mb-4">
            <label class="form-label mt-3">Клиент</label>
            <span>
                {{ forms.contracts.selectedItem.client_name }}
            </span>

            <label class="form-label mt-3">Организация</label>
            <span>
                {{ forms.contracts.selectedItem.organization_name }}
            </span>

            <label class="form-label mt-3">Договор</label>
            <span>
                {{ forms.contracts.selectedItem.name }} №{{ forms.contracts.selectedItem.number }}
            </span>
        </div>

        <div v-else>
            <div class="mb-4">
                <label class="form-label">Клиент</label>
                <select @change="onChangeClient($event)"
                        v-model="forms.client.selected"
                        class="form-select">
                    <option v-for="client in forms.client.items" v-bind:value="client.id">
                        {{ client.name }}
                    </option>
                </select>
            </div>

            <div class="mb-4">
                <div class="form-label">Организация</div>
                <select :disabled="!forms.client.selected"
                        v-model="forms.organization.selected"
                        class="form-select">
                    <option v-for="organization in forms.organization.items" v-bind:value="organization.id">
                        {{ organization.name }}
                    </option>
                </select>
            </div>

            <div class="mb-4">
                <div class="form-label">Договор</div>
                <select :disabled="!forms.client.selected"
                        v-model="forms.contracts.selected"
                        class="form-select">
                    <option v-for="contract in forms.contracts.items" v-bind:value="contract.contract_id">
                        {{ contract.contract_name }} №{{ contract.contract_number }}
                    </option>
                </select>
            </div>
        </div>

        <div class="mb-4">
            <label class="form-label">Название</label>
            <input
                type="text"
                class="form-control mb-3"
                v-model="forms.data.name"
                placeholder="Введите название доп соглашения">
        </div>

        <div class="mb-4">
            <div class="form-label">Номер</div>
            <input
                type="text"
                class="form-control mb-3"
                v-model="forms.data.number"
                placeholder="Введите номер доп соглашения">
        </div>

        <div class="mb-4">
            <label class="form-label">Дата начала действие</label>
            <input
                type="date"
                class="form-control mb-3"
                v-model="forms.data.date"
                placeholder="Введите дату начала действия доп соглашения">
        </div>

        <div class="mb-4">
            <label class="form-label">Файл</label>
            <input
                accept="application/pdf"
                ref="contractFile"
                @change="onChangeFile($event)"
                type="file"
                class="form-control mb-3">
        </div>
    </form>

    <div class="col-md-4">
        <div class="d-flex align-items-stretch py-3">
            <button @click="create" class="btn btn-md btn-primary flex-grow-1 me-3">
                Добавить
            </button>
            <a :href="contacts_list" class="btn btn-md btn-outline-dark flex-grow-1">
                Отменить
            </a>
        </div>
    </div>

    <Alert />
</template>

<script>
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "ContractAdditionalCreateComponent",
    components: { Alert },
    props: {
        contract_id: {
            type: [Number, String],
            default: 0
        },
        contacts_list: String
    },
    data: function () {
        return {
            forms: {
                client: {
                    selected: null,
                    items: []
                },
                organization: {
                    selected: null,
                    items: []
                },
                data: {
                    name: null,
                    date: null,
                    number: null
                },
                file: {
                    selected: null
                },
                searchingContracts: {
                    openDropDown: false,
                    items: [],
                    selectedItem: null,
                    searchingControl: null
                },
                contracts: {
                    selected: !this.contract_id ? null : this.contract_id,
                    selectedItem: null,
                    items: []
                }
            },
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        getContract: async function () {
            let resp = await axios.get('/documents/contracts/get', {params: {
                    id: this.forms.contracts.selected,
                }}).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить договор, что-то пошло не так' });
            });

            if (resp.data.item !== null) {
                if (resp.data.status === 'ok') {
                    this.forms.contracts.selectedItem = resp.data.item
                } else {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
                }
            }
        },
        getClients: async function () {
            let resp = await axios.get('/organizational/client/list', {params: {
                    page: 1,
                    limit: 100
                }}).catch(_ => {
                    this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Не удалось получить список клиентов, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.forms.client.items = resp.data.items;
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
        getOrgs: async function () {
            let resp = await axios.get('/organizational/organizations/list', {params: {
                    page: 1,
                    limit: 100,
                    client_id: this.forms.client.selected
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список организаций, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.forms.organization.items = resp.data.items;
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
        getContracts: async function () {
            const resp = await axios.get('/documents/contracts/list', {params: {
                    page: 1,
                    limit: 100,
                    client_id: this.forms.client.selected
                }}).catch(res => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список договоров, что-то пошло не так' });
            });

            if (resp.data.status !== 'ok') {
                alert(resp.data.message);
            }

            if (resp.data.status === 'ok') {
                this.forms.contracts.items = resp.data.items;
            }
        },
        onChangeClient: async function (e) {
            this.forms.client.selected = e.target.value;
            await this.getOrgs();
            await this.getContracts();
        },
        onChangeFile: function (e) {
            if (!e.target.files[0] || e.target.files[0].type !== 'application/pdf') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Только файлы с расширением pdf' });
                e.target.value = null;
            }

            if (e.target.files[0] && e.target.files[0].type === 'application/pdf') {
                this.forms.file.selected = e.target.files[0];
            }
        },
        create: async function() {
            if (!this.forms.contracts.selectedItem) {
                if (!this.forms.client.selected) {
                    this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите клиента' });
                    return;
                }

                if (!this.forms.organization.selected) {
                    this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите организацию' });
                    return;
                }

                if (!this.forms.searchingContracts) {
                    this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите договор' });
                    return;
                }
            }

            if (!this.forms.data.name) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите название документа' });
                return;
            }

            if (!this.forms.data.number) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите номер документа' });
                return;
            }

            if (!this.forms.data.date) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите дату документа' });
                return;
            }

            if (!this.forms.file.selected) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Добавьте файл' });
                return;
            }

            const formData = new FormData();

            formData.append('client_id', this.forms.contracts.selectedItem ? this.forms.contracts.selectedItem.client_id : this.forms.client.selected);
            formData.append('org_id', this.forms.contracts.selectedItem ? this.forms.contracts.selectedItem.organization_id : this.forms.organization.selected);
            formData.append('contract_id', this.forms.contracts.selectedItem ? this.forms.contracts.selectedItem.id : this.forms.contracts.selected);
            formData.append('name', this.forms.data.name);
            formData.append('number', this.forms.data.number);
            formData.append('date', this.forms.data.date);
            formData.append('file', this.forms.file.selected);

            const resp = await axios.post('/documents/contracts/create/contract-additional', formData).catch(res => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось добавить дополнительное соглашение к договору, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.addAlert({ type: 'success', title: 'Успешно', text: 'Дополнительное соглашение к договору успешно добавлено' });
                window.location.href = this.contacts_list;
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
    },
    async mounted() {
        await this.getContract();
        if (!this.forms.contracts.selectedItem) {
            await this.getContracts();
            await this.getOrgs();
            await this.getClients();
        }
    }
}
</script>

<style scoped>
.app-dropdown {
    border-radius: 5px;
    position: relative;
}

.app-dropdown .manager {
    border: 1px solid #ddd;
    border-radius: 4px;
}

.app-dropdown .items-block {
    position: relative;
    height: 200px;
    overflow: auto;
    z-index: 9999;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

.app-dropdown .items-block .searching-block {
    position: sticky;
    top: 0;
    background-color: #fff;
}

.app-dropdown .items-block .searching-block input {
    border-bottom: 1px solid #ddd;
    border-top: none;
    border-radius: 0;
    border-left: none;
    border-right: none;
}

.app-dropdown .items {
    position: absolute;
    width: 100%;
}

.app-dropdown .items .item {
    padding: 0 10px;
    cursor: pointer;
    font-size: 16px;
}

.app-dropdown .items .item:hover {
    background-color: #3c7af0;
    color: white;
}

.app-dropdown .hidden {
    display: none;
}

.app-dropdown .manager {
    padding: 15px;
    height: 40px;
    cursor: pointer;
}

.app-dropdown .manager .button {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;
    background-position: center right;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
}

.app-dropdown .shade {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 999;
    min-height: 100vh;
    overflow: hidden;
}

.app-dropdown .content {
    position: absolute;
    width: 100%;
    height: 200px;
}

.app-dropdown .disable {
    background-color: #ddd;
    cursor: initial;
}
</style>
